import React from 'react'

const OptionComponent = ({index, nome}) => {
    return (
        <option value={index} className={nome}>{nome}</option>
    )
}

export default OptionComponent
